import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../../shared/components/snackbar/snackbar-custom.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../../core/models/response.model'
import { MatInputModule } from '@angular/material/input'
import { MatOption } from '@angular/material/core'
import { MatSelect } from '@angular/material/select'
import { PaymentTypeService } from '../../../../core/services/payment/payment-type/payment-type.service'
import { PaymentMethodsService } from '../../../../core/services/payment/payment-methods/payment-methods.service'
import { JsonPipe } from '@angular/common'

@Component({
  selector: 'payment-methods-client-edit-form',
  imports: [
    FormsModule,
    MatButton,
    MatProgressSpinner,
    ReactiveFormsModule,
    MatInputModule,
    MatOption,
    MatSelect,
    JsonPipe,
  ],
  templateUrl: './payment-methods-client-edit-form.component.html',
  styleUrl: './payment-methods-client-edit-form.component.scss',
  providers: [PaymentTypeService, PaymentMethodsService],
  standalone: true,
})
export class PaymentMethodsClientEditFormComponent
  implements OnInit, OnChanges
{
  constructor(
    private formBuilder: FormBuilder,
    private snackbar: SnackbarCustomService,
    private paymentTypeService: PaymentTypeService,
    private paymentMethodsService: PaymentMethodsService,
  ) {}

  form: FormGroup = new FormGroup({})
  loading: boolean = false

  @Output() response = new EventEmitter()
  @Input() editItem: any = {}
  @Input() personId: number = 0

  listType: any[] = []

  ngOnInit(): void {
    this.getListType()
    this.createForm()
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['editItem']) {
      this.treatmentItem()
    }
  }

  private treatmentItem() {
    if (this.checkEdit()) {
      this.form.reset()
      this.fillForm()
    }
  }

  getListType() {
    this.paymentTypeService.listPaymentType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listType = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  checkEdit() {
    if (this.editItem) {
      if (this.editItem.edit) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }

  fillForm() {
    this.form.get('paymentTypeId')?.setValue(this.editItem.data.tipoPagamentoId)
    this.form.get('term')?.setValue(this.editItem.data.prazo)
  }

  resetForm() {
    this.form.reset()
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      paymentTypeId: ['', [Validators.required]],
      term: ['', [Validators.required]],
    })
  }

  createPaymentMethod() {
    this.loading = true
    const model = this.createModel()
    this.paymentMethodsService.createPaymentMethods(model).subscribe({
      next: (response: any) => {
        this.snackbar.success(response.message)
        this.response.emit({ refresh: true, clear: true })
        this.resetForm()
        this.loading = false
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
      },
    })
  }

  editPaymentMethod() {
    this.loading = true
    const model = this.createModel(true)
    this.paymentMethodsService.editPaymentMethods(model).subscribe({
      next: (response: any) => {
        this.snackbar.success(response.message)
        this.response.emit({ refresh: true, clear: true })
        this.resetForm()
        this.loading = false
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
      },
    })
  }

  cancel() {
    this.response.emit({ refresh: false, clear: true })
    this.resetForm()
  }

  createModel(edit: boolean = false) {
    if (edit) {
      return {
        id: this.editItem.data.id,
        pessoaId: this.personId,
        tipoPagamentoId: this.form.controls['paymentTypeId'].value,
        prazo: this.form.controls['term'].value,
        // crc: this.editItem.data.crc,
      }
    } else {
      return {
        pessoaId: this.personId,
        tipoPagamentoId: this.form.controls['paymentTypeId'].value,
        prazo: this.form.controls['term'].value,
      }
    }
  }
}
